import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Sponsors',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'projects',
                },
              },
              subqueries: {
                projects: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'awardOrgs',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'pis',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!sponsors:!sponsor',
                  subqueries: {
                    pis: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        '=': [
                          {
                            '@.': '!id',
                          },
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                        ],
                      },
                      target: 'ent:!personnel:!employee',
                    },
                    awards: {
                      ref: {
                        attr: 'attr:ent#!awards#!award:!sponsor',
                      },
                      target: 'ent:!awards:!award',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!award',
                      },
                      using: 'awards',
                      target: 'ent:!projects:!proj',
                    },
                    awardOrgs: {
                      using: 'awards',
                      filter: {
                        and: [
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!awards:!award',
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      using: 'projects',
                      target: 'ent:!proj_pis:!entry',
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '!=': [
                          {
                            '@': 'awardOrgs',
                          },
                          null,
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>': [
                          {
                            '#': {
                              '@': 'pis',
                            },
                          },
                          0,
                        ],
                      },
                    ],
                  },
                ],
              },
              period: {
                $range: {
                  end: {
                    $date: '12/31/2024',
                  },
                  start: {
                    $date: '1/1/2024',
                  },
                },
              },
              target: 'ent:!sponsors:!sponsor',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      tdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'glExpenses',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      idcr: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'totalIdcr',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'glExpensesInMtdc',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      type: {
                        '{}': {
                          value: {
                            '@.': '!type',
                          },
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'glExpensesInMtdcInLastThreeYears',
                                    },
                                  },
                                  0,
                                ],
                              },
                              3,
                            ],
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'projects',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      awardFunding: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'awardsFilteredByResearchType',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      collaborations: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'collaborations',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '+': {
                                        '@': 'glExpensesInMtdc',
                                      },
                                    },
                                    null,
                                    0,
                                  ],
                                },
                                {
                                  '/': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '@': 'totalIdcr',
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '+': {
                                        '@': 'glExpensesInMtdc',
                                      },
                                    },
                                  ],
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      collaborationPercent: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'collaborations',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'projects',
                                    },
                                  },
                                  1,
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                pis: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!pi',
                  },
                  using: 'projectPiAssignments',
                  filter: {
                    '=': [
                      {
                        '@.': '!id',
                      },
                      {
                        '``': {
                          '@$': 'piRecordId',
                        },
                      },
                    ],
                  },
                  target: 'ent:!personnel:!employee',
                },
                awards: {
                  ref: {
                    attr: 'attr:ent#!awards#!award:!sponsor',
                  },
                  target: 'ent:!awards:!award',
                },
                projects: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!award',
                  },
                  using: 'awards',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@.': '!research_type_wfuhs',
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!projects:!proj',
                },
                awardOrgs: {
                  using: 'awards',
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': [
                      '!org',
                      {
                        ref: {
                          '``': {
                            '@$': 'orgEntityId',
                          },
                        },
                      },
                    ],
                  },
                },
                totalIdcr: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!acct',
                          {
                            ref: {
                              entity: '!acct',
                            },
                          },
                        ],
                      },
                      '?7631013',
                    ],
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                  },
                },
                glExpenses: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  target: 'ent:!gl_exp:!entry',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@': 'projectsResearchType',
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    projectsResearchType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!research_type_wfuhs',
                      },
                    },
                  },
                },
                collaborations: {
                  using: 'projects',
                  filter: {
                    '>': [
                      {
                        '#': {
                          uniq: {
                            '@': 'piDepartments',
                          },
                        },
                      },
                      1,
                    ],
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '@.': '!id',
                  },
                  subqueries: {
                    piDepartments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      target: 'ent:!personnel:!employee',
                      selection: {
                        '@.': [
                          '!org',
                          {
                            ref: {
                              entity: '!dept',
                            },
                          },
                        ],
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                  },
                },
                glExpensesInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '@': 'isInMtdc',
                      },
                    ],
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                    projectsResearchType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!research_type_wfuhs',
                      },
                    },
                  },
                },
                projectPiAssignments: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!proj',
                  },
                  using: 'projects',
                  target: 'ent:!proj_pis:!entry',
                },
                awardsFilteredByResearchType: {
                  ref: {
                    attr: 'attr:ent#!awards#!award:!sponsor',
                  },
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@.': '!research_type_wfuhs',
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': '!budget',
                  },
                },
                glExpensesInMtdcInLastThreeYears: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '@': 'isInMtdc',
                      },
                    ],
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '12/31/2024',
                      },
                      start: {
                        $date: '1/1/2022',
                      },
                    },
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                    projectsResearchType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!research_type_wfuhs',
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!sponsors#!sponsor:!code',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!sponsors#!sponsor:!name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'type',
                  direct: {
                    '{}': {
                      name: 'Sponsor Type',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'awardFunding',
                  direct: {
                    '{}': {
                      name: 'Award Funding',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'tdc',
                  direct: {
                    '{}': {
                      name: 'TDC Expense',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'mtdc',
                  direct: {
                    '{}': {
                      name: 'MTDC Expense',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'mtdcAvg',
                  direct: {
                    '{}': {
                      name: 'MTDC Average',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'idcr',
                  direct: {
                    '{}': {
                      name: 'IDC-R',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'effectiveRecovery',
                  direct: {
                    '{}': {
                      name: 'Effective Recovery',
                      type: 'PERCENT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'projects',
                  direct: {
                    '{}': {
                      name: 'Projects',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'collaborations',
                  direct: {
                    '{}': {
                      name: 'Collaborations',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'collaborationPercent',
                  direct: {
                    '{}': {
                      name: 'Collaboration %',
                      type: 'PERCENT',
                    },
                  },
                },
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      tdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      idcr: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcr',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcInLastThreeYears',
                                      ],
                                    },
                                  ],
                                },
                              },
                              3,
                            ],
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'projects',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      awardFunding: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'awardFunding',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      collaborations: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'collaborations',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'effectiveRecovery',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      collaborationPercent: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'collaborationPercent',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'awardOrgs',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>': [
                              {
                                '#': {
                                  '@': 'pis',
                                },
                              },
                              0,
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '12/31/2024',
                      },
                      start: {
                        $date: '1/1/2024',
                      },
                    },
                  },
                  target: 'ent:!sponsors:!sponsor',
                  selection: {
                    '{}': {
                      tdc: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpenses',
                            },
                          },
                          0,
                        ],
                      },
                      idcr: {
                        '??': [
                          {
                            '+': {
                              '@': 'totalIdcr',
                            },
                          },
                          0,
                        ],
                      },
                      mtdc: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpensesInMtdc',
                            },
                          },
                          0,
                        ],
                      },
                      projects: {
                        '??': [
                          {
                            '#': {
                              '@': 'projects',
                            },
                          },
                          0,
                        ],
                      },
                      awardFunding: {
                        '??': [
                          {
                            '+': {
                              '@': 'awardsFilteredByResearchType',
                            },
                          },
                          0,
                        ],
                      },
                      collaborations: {
                        '??': [
                          {
                            '#': {
                              '@': 'collaborations',
                            },
                          },
                          0,
                        ],
                      },
                      effectiveRecovery: {
                        if: [
                          [
                            {
                              '!=': [
                                {
                                  '+': {
                                    '@': 'glExpensesInMtdc',
                                  },
                                },
                                null,
                                0,
                              ],
                            },
                            {
                              '/': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'totalIdcr',
                                      },
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '+': {
                                    '@': 'glExpensesInMtdc',
                                  },
                                },
                              ],
                            },
                          ],
                          0,
                        ],
                      },
                      collaborationPercent: {
                        '/': [
                          {
                            '??': [
                              {
                                '#': {
                                  '@': 'collaborations',
                                },
                              },
                              0,
                            ],
                          },
                          {
                            '??': [
                              {
                                '#': {
                                  '@': 'projects',
                                },
                              },
                              1,
                            ],
                          },
                        ],
                      },
                      mtdcInLastThreeYears: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpensesInMtdcInLastThreeYears',
                            },
                          },
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    pis: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        '=': [
                          {
                            '@.': '!id',
                          },
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                        ],
                      },
                      target: 'ent:!personnel:!employee',
                    },
                    awards: {
                      ref: {
                        attr: 'attr:ent#!awards#!award:!sponsor',
                      },
                      target: 'ent:!awards:!award',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!award',
                      },
                      using: 'awards',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': '!research_type_wfuhs',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!projects:!proj',
                    },
                    awardOrgs: {
                      using: 'awards',
                      filter: {
                        and: [
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!awards:!award',
                      selection: {
                        '@.': [
                          '!org',
                          {
                            ref: {
                              '``': {
                                '@$': 'orgEntityId',
                              },
                            },
                          },
                        ],
                      },
                    },
                    totalIdcr: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      filter: {
                        '=': [
                          {
                            '@.': [
                              '!acct',
                              {
                                ref: {
                                  entity: '!acct',
                                },
                              },
                            ],
                          },
                          '?7631013',
                        ],
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                      },
                    },
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!gl_exp:!entry',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@': 'projectsResearchType',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    collaborations: {
                      using: 'projects',
                      filter: {
                        '>': [
                          {
                            '#': {
                              uniq: {
                                '@': 'piDepartments',
                              },
                            },
                          },
                          1,
                        ],
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!id',
                      },
                      subqueries: {
                        piDepartments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!pi',
                          },
                          using: 'projectPiAssignments',
                          target: 'ent:!personnel:!employee',
                          selection: {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: '!dept',
                                },
                              },
                            ],
                          },
                        },
                        projectPiAssignments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          target: 'ent:!proj_pis:!entry',
                        },
                      },
                    },
                    glExpensesInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'projectsResearchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@': 'isInMtdc',
                          },
                        ],
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      using: 'projects',
                      target: 'ent:!proj_pis:!entry',
                    },
                    awardsFilteredByResearchType: {
                      ref: {
                        attr: 'attr:ent#!awards#!award:!sponsor',
                      },
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': '!research_type_wfuhs',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!awards:!award',
                      selection: {
                        '@.': '!budget',
                      },
                    },
                    glExpensesInMtdcInLastThreeYears: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'projectsResearchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            '@': 'isInMtdc',
                          },
                        ],
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2024',
                          },
                          start: {
                            $date: '1/1/2022',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        projectsResearchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    researchType: ['BASIC RESEARCH'],
  },
}
